let getWeigthProductModal = null;

$(document).ready(function () {
  getWeigthProductModal = function (productId, quantity = 0, cartIndex = null) {
    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/products/get-weigth-product-modal',
      data: {
        product_id: productId,
        quantity,
        cartIndex,
      },
    })
      .done(function (data) {
        if (data.html) {
          if ($('#weightProductModal').length) {
            $('#weightProductModal').remove();
            $('.modal-backdrop').remove();
          }
          $('#content').append(data.html);
          setTimeout(() => {
            $('#weightProductModal').modal('show');
          }, 300);
        }
      })
      .fail(function (data) {});
  };

  $(document).on('click', '.show-weight-product-modal', function () {
    const productId = $(this).attr('data-product-id');
    const cartIndex = $(this).attr('data-cart-index');
    const quantityInput = $(this)
      .closest('.product-qty-container')
      .find('.cart-product-amount');
    const quantity = quantityInput.val();

    getWeigthProductModal(productId, quantity, cartIndex);
  });

  $(document).on('change', '#is_weight_product', function (e) {
    e.preventDefault();
    const weightProductChecked = $(this).is(':checked');
    const isVolumeCheckbox = $('#is_volume');
    const isMenuProductCheckBox = $('#is_menu_product');
    const openPriceCheckBox = $('#open-price');
    if (weightProductChecked) {
      isVolumeCheckbox.prop('checked', false).prop('disabled', true);
      isMenuProductCheckBox.prop('checked', false).prop('disabled', true);
      openPriceCheckBox.prop('checked', false).prop('disabled', true);
    } else {
      isVolumeCheckbox.prop('disabled', false);
      isMenuProductCheckBox.prop('disabled', false);
      openPriceCheckBox.prop('disabled', false);
    }
  });

  function getCurrentValue() {
    return $('#weightValue').val();
  }

  $(document).on('click', '#add-weight-product-btn', function () {
    const $modal = $('#weightProductModal');

    // Ignore a second Enter while the modal is already closing
    if (!$modal.hasClass('show')) {
      return;
    }

    const productId = $modal.data('product-id');
    const amount = parseFloat(getCurrentValue()) || 0;
    const originalPrice = parseFloat($(this).attr('data-product-price'));

    if (amount <= 0) {
      $('#weightValue').addClass('is-invalid');
      return;
    }

    $('#weightValue').removeClass('is-invalid');

    // Same merge rules as the classic add-product handler, so discounted, takeaway and table lines stay separate
    const productIndex = locationCart.products.findIndex(
      (obj) =>
        obj.product_id == productId &&
        !('product_extra' in obj) &&
        ((!(obj.is_takeaway == 1) && !locationCart.is_takeaway_checked) ||
          (obj.is_takeaway == 1 && locationCart.is_takeaway_checked)) &&
        parseFloat(obj.discount_percent) == 0 &&
        !obj.product_table_id &&
        !obj.product_table_split_id
    );

    if (productIndex !== -1) {
      locationCart.products[productIndex].amount =
        parseFloat(locationCart.products[productIndex].amount) + amount;
    } else {
      let product = {
        product_id: productId,
        amount: amount,
        comment: '',
        discount_percent: locationCart.order_discount_percent || 0,
        original_product_price: originalPrice,
        is_open_price: 0,
        is_takeaway: 0,
      };
      locationCart.products.unshift(product);
      locationCart.number_of_products =
        parseInt(locationCart.number_of_products) + 1;
    }

    let priceInclVat = originalPrice * amount;

    locationCart.amount = parseFloat(locationCart.amount) + priceInclVat;
    updateCartSummary();
    updateCartProducts();

    $modal.modal('hide');
  });

  $(document).on('click', '#update-weight-product-btn', function () {
    const $modal = $('#weightProductModal');

    if (!$modal.hasClass('show')) {
      return;
    }

    const productId = $modal.data('product-id');
    const cartIndex = $modal.data('cart-index');
    const amount = parseFloat(getCurrentValue()) || 0;
    const originalPrice = parseFloat($(this).attr('data-product-price'));

    if (amount <= 0) {
      $('#weightValue').addClass('is-invalid');
      return;
    }

    $('#weightValue').removeClass('is-invalid');

    let priceInclVat = originalPrice * amount;

    let oldAmount = parseFloat(locationCart.products[cartIndex].amount);
    let oldPriceIncVat =
      parseFloat(locationCart.products[cartIndex].original_product_price) *
      oldAmount;
    locationCart.products[cartIndex].amount = amount;
    locationCart.amount =
      parseFloat(locationCart.amount) + priceInclVat - oldPriceIncVat;
    updateCartSummary();
    updateCartProducts();

    $modal.modal('hide');
  });

  $(document).on('show.bs.modal', '#weightProductModal', function () {
    $('#weightValue').removeClass('is-invalid');
  });

  $(document).on('shown.bs.modal', '#weightProductModal', function () {
    const input = $('#weightValue').trigger('focus')[0];
    input.setSelectionRange(input.value.length, input.value.length);
  });

  $(document).on('input', '#weightValue', function () {
    $(this).removeClass('is-invalid');
  });
});
